// Floating settings FAB — desktop only. On mobile, a fixed floating
// button risks overlapping short page content (confirmed while testing
// the supplier queue with only a few rows — the FAB sat directly over
// the last card's status chip, since a fixed-position element's
// viewport offset can't be fixed by adding trailing padding to the
// content above it). On mobile, the same controls are reachable from
// the profile menu instead (AdminHeader.jsx's AppearanceDialog).
import React, { useEffect, useState } from "react";
import { Box, Fab, Paper, Typography, Tooltip, Zoom, ClickAwayListener, useMediaQuery, useTheme } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AppearancePanel from "./AppearancePanel";

export default function SettingsFab() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      setShowScrollTop(scrolled > 200);
    };
    window.addEventListener("scroll", onScroll, true);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll, true);
  }, []);

  if (isMobile) return null;

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 1400, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1.5 }}>
        <Zoom in={open} unmountOnExit>
          <Paper elevation={8} sx={{ position: "absolute", bottom: 64, right: 0, width: 240, borderRadius: 3, overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" }}>
            <Box sx={{ px: 2, py: 1.5, bgcolor: "primary.main", display: "flex", alignItems: "center", gap: 1 }}>
              <SettingsIcon sx={{ color: "#fff", fontSize: 18 }} />
              <Typography variant="body2" sx={{ color: "#fff", fontWeight: 600 }}>Appearance</Typography>
            </Box>
            <Box sx={{ p: 2 }}>
              <AppearancePanel />
            </Box>
          </Paper>
        </Zoom>

        <Zoom in={showScrollTop} unmountOnExit>
          <Tooltip title="Scroll to top" placement="left">
            <Fab size="small" color="primary" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} sx={{ boxShadow: "0 4px 16px rgba(0,0,0,0.22)" }}>
              <KeyboardArrowUpIcon />
            </Fab>
          </Tooltip>
        </Zoom>

        <Fab
          size="medium"
          color="primary"
          onClick={() => setOpen((v) => !v)}
          sx={{
            boxShadow: "0 4px 16px rgba(0,0,0,0.22)",
            "& svg": { animation: "spin 3s linear infinite", "@keyframes spin": { "0%": { transform: "rotate(0deg)" }, "100%": { transform: "rotate(360deg)" } } },
          }}
        >
          <SettingsIcon />
        </Fab>
      </Box>
    </ClickAwayListener>
  );
}
